// Domain Input Store Extension

import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const domainInputStoreExtension = ModuleExtensions.storeExtension({
  query: '',
  tlds: [],
  keywords: [],
  style: undefined,
  businessInfo: undefined,
  submittedDomain: undefined,
  submittedFilters: undefined,
  inputRef: null
}, 'domainInputStore', {
  useQuery: state => state.query,
  useTlds: state => state.tlds,
  useKeywords: state => state.keywords,
  useStyle: state => state.style,
  useBusinessInfo: state => state.businessInfo,
  useSubmittedFilters: state => state.submittedFilters,
  useSearchFilters: state => ({
    query: state.query,
    tlds: state.tlds,
    keywords: state.keywords,
    style: state.style,
    businessInfo: state.businessInfo
  }),
  useSubmittedDomain: state => state.submittedDomain,
  useInputRef: state => state.inputRef
}, {
  setQuery: (_ref, query) => {
    let {
      draft
    } = _ref;
    draft.query = query;
  },
  setTlds: (_ref2, tlds) => {
    let {
      draft
    } = _ref2;
    draft.tlds = tlds;
  },
  setKeywords: (_ref3, keywords) => {
    let {
      draft
    } = _ref3;
    draft.keywords = keywords;
  },
  setStyle: (_ref4, style) => {
    let {
      draft
    } = _ref4;
    draft.style = style;
  },
  setBusinessInfo: (_ref5, businessInfo) => {
    let {
      draft
    } = _ref5;
    draft.businessInfo = businessInfo;
  },
  setSubmittedFilters: (_ref6, submittedFilters) => {
    let {
      draft
    } = _ref6;
    draft.submittedFilters = submittedFilters;
  },
  setSubmittedDomain: (_ref7, submittedDomain) => {
    let {
      draft
    } = _ref7;
    draft.submittedDomain = submittedDomain == null ? void 0 : submittedDomain.trim();
  },
  setInputRef: (_ref8, inputRef) => {
    let {
      draft
    } = _ref8;
    draft.inputRef = inputRef;
  },
  setFilters: (_ref9, filters) => {
    let {
      draft
    } = _ref9;
    draft.tlds = filters.tlds;
    draft.keywords = filters.keywords;
    draft.style = filters.style;
  },
  clearFilters: _ref10 => {
    let {
      draft
    } = _ref10;
    draft.tlds = [];
    draft.keywords = [];
    draft.style = undefined;
    draft.businessInfo = undefined;
    draft.submittedDomain = undefined;
  },
  resetState: _ref11 => {
    let {
      draft
    } = _ref11;
    draft.query = '';
    draft.tlds = [];
    draft.keywords = [];
    draft.style = undefined;
    draft.businessInfo = undefined;
    draft.submittedDomain = undefined;
    draft.inputRef = null;
  }
});
//# sourceMappingURL=store.js.map